import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  MaterialImportRequest,
  MaterialImportResult,
  MaterialListQuery,
  MaterialRow,
  MaterialSaveRequest,
  MaterialSaveResult
} from '../types/material';
import type { PageResult } from '../types/result';

const BASE = '/wl/material';

/** 物资主数据：查询对所有登录账号开放，新建/维护需 `wl:purchase:manage`。 */
export function createMaterialApi(http: HttpClient) {
  return {
    list(query: MaterialListQuery = {}): Promise<PageResult<MaterialRow>> {
      return http.request<PageResult<MaterialRow>>({ path: BASE, query: toQuery(query) });
    },

    detail(id: Id): Promise<MaterialRow> {
      return http.request<MaterialRow>({ path: `${BASE}/${id}` });
    },

    /** 新建（`id` 为空）或维护。编码由服务端按「M-分类段-4 位序号」生成，前端不提交。 */
    save(body: MaterialSaveRequest): Promise<MaterialSaveResult> {
      return http.request<MaterialSaveResult>({ path: BASE, method: 'POST', body });
    },

    /** 批量导入（Excel/CSV 粘贴行）：分类/单位按编码或名称匹配，不合格行逐行回显。 */
    import(body: MaterialImportRequest): Promise<MaterialImportResult> {
      return http.request<MaterialImportResult>({ path: `${BASE}/import`, method: 'POST', body });
    }
  };
}

export type MaterialApi = ReturnType<typeof createMaterialApi>;
